import React, { useState } from 'react';
import MppContextProvider from './context/MppContextProvider';

import IMSContext from './context/IMSContext';
import { Box, Grid } from '@mui/material';
import Header from './tab/Header';
import { PageTitle } from '../../components/StyledComponents';
import PowerBiEmbedded from '../../components/PowerBIPublicEmbed/PowerBiEmbedded';
import ExpandableSection from '../../components/ExpandableSection/ExpandableSection';
import { powerbiConfig } from '../../config/powerbi';

const MasterSchedule = ({ hideHeader = false }) => {
  const [status, setStatus] = useState('Table View');

  const ganttView = (
    <Box sx={{ flex: 1, minHeight: '400px', position: 'relative' }}>
      <PowerBiEmbedded
        reportId={powerbiConfig.masterSchedule.reportId}
        datasetId={powerbiConfig.masterSchedule.datasetId}
      />
    </Box>
  );

  return (
    <MppContextProvider>
      <Box sx={{ width: '100%', height: '100%', p: hideHeader ? 0 : 3 }}>
        <Grid container spacing={2} sx={{ mb: 2, height: '100%' }}>
          <Grid
            size={{ xs: 8, md: 8, lg: 12, xl: 12 }}
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            {hideHeader ? (
              // Home widget: keep the Table/Gantt tabbed view.
              <>
                <Header setStatus={setStatus} hideTitle={hideHeader} />
                {status === 'Table View' && (
                  <IMSContext value={status} index={0} />
                )}
                {status === 'Gantt View' && ganttView}
              </>
            ) : (
              // Standalone page: stack the two widgets, each in a collapsible
              // card with a fullscreen expander (matching the Home page).
              <Box sx={{ mt: 2 }}>
                <PageTitle>Schedule</PageTitle>
                <Box sx={{ mt: 2 }}>
                  <ExpandableSection title="Table View" defaultExpanded>
                    <IMSContext value={'Table View'} index={0} />
                  </ExpandableSection>
                  <ExpandableSection
                    title="Gantt View"
                    defaultExpanded
                    collapsedHeight="500px"
                  >
                    {/* Wrapper participates in column flex so ganttView's
                        inner flex:1 has room to grow into. */}
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      {ganttView}
                    </Box>
                  </ExpandableSection>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </MppContextProvider>
  );
};

export default MasterSchedule;
